import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { Element } from "react-scroll";
import { StyleTypeContext, TranslationContext } from "../../../umbilical_tools";
import { useSelector } from "react-redux";
import jssVariables from "../../../jss_setup";
import { BtmInfo, PriceAndActions } from "./helpers";
import { common_assets_s3 } from "../../../variables";
import { getFilteredSessionFerriesSelector } from "../../../selectors/ferries";
import { handleNonValidImgFn } from "../../../umbilical_tools";
import TripInfo from "../TripInfo";

export function onViewFerryDetails({
  history,
  token,
  provider,
  page_session_id,
}) {
  const data = window.btoa(JSON.stringify({ provider, token }));
  history.push({
    pathname: `/ferry_details/${page_session_id}`,
    search: `?data=${data}`,
  });
}

const btmBtnsGrey = "#e5e5e5";
const btmBtnsStyles = {
  display: "grid",
  placeItems: "center",
  textAlign: "center",
  borderRadius: jssVariables.half_gap,
  cursor: "pointer",
  padding: `calc(${jssVariables.normal_gap} / 4) ${jssVariables.half_gap}`,
  color: jssVariables.colors.base_color,
  "&:hover": {
    background: btmBtnsGrey,
    borderColor: btmBtnsGrey,
  },
};

function labelBestSomethingStyles() {
  return {
    display: "grid",
    color: "white",
    padding: `calc(${jssVariables.normal_gap} / 3) ${jssVariables.normal_gap}`,
    borderRadius: jssVariables.double_gap,
    textTransform: "capitalize",
    height: "max-content",
    smallscreen: {
      fontSize: "small",
      padding: `0 ${jssVariables.double_gap}`,
    },
  };
}
const styles = createUseStyles({
  Ferry: (props) => ({
    position: "relative",
    gridTemplateRows: `${jssVariables.card_img_height_mobile} 1fr`,
    borderRadius: jssVariables.border_radius,
    boxShadow: jssVariables.shadows.smallShadow,
    width: "90vw",
    color: jssVariables.colors.text.dark,
    background: "white",
    ..._.get(props, "customStyles.ferry", {}),
  }),
  placeholderParagraph: (props) => ({
    padding: `calc(${jssVariables.normal_gap} * 1.5)`,
    ..._.get(props, "customStyles.placeholderParagraph", {}),
  }),
  header: (props) => ({
    display: "grid",
    padding: `calc(${jssVariables.normal_gap} * 1.5)`,
    gridTemplateColumns: "max-content 1fr",
    justifyContent: "space-between",
    background: "#f5f5f5",
    borderTopRightRadius: jssVariables.border_radius,
    borderTopLeftRadius: jssVariables.border_radius,
    alignItems: "start",
    ..._.get(props, "customStyles.header", {}),
  }),
  bestSmthContr: (props) => ({
    display: "grid",
    gridTemplateColumns: "max-content max-content",
    gridGap: jssVariables.half_gap,
    justifySelf: "end",
    ..._.get(props, "customStyles.bestSmthContr", {}),
  }),
  provider: (props) => ({
    display: "grid",
    textTransform: "capitalize",
    fontSize: "medium",
    justifyItems: "center",
    ..._.get(props, "customStyles.provider", {}),
  }),
  providerImg: (props) => ({
    height: "2rem",
    maxWidth: "8rem",
    objectFit: "contain",
    ..._.get(props, "customStyles.providerImg", {}),
  }),
  content: (props) => ({
    padding: `${jssVariables.normal_gap} calc(${jssVariables.normal_gap} * 1.5)`,
    ..._.get(props, "customStyles.content", {}),
  }),
  labelFastest: (props) => ({
    ...labelBestSomethingStyles(),
    background: "#17a600",
    ..._.get(props, "customStyles.labelFastest", {}),
  }),
  labelCheapest: (props) => ({
    ...labelBestSomethingStyles(),
    background: "#E10000",
    ..._.get(props, "customStyles.labelCheapest", {}),
  }),
  dividerMobile: (props) => ({
    width: "100%",
    margin: `${jssVariables.double_gap} 0`,
    ..._.get(props, "customStyles.dividerMobile", {}),
  }),
  dividerDesktop: (props) => ({
    display: "none",
    ..._.get(props, "customStyles.dividerDesktop", {}),
  }),
  btmInfoSection: (props) => ({
    display: "grid",
    paddingTop: jssVariables.double_gap,
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.btmInfoSection", {}),
  }),
  btmButtonCheckin: (props) => ({
    ...btmBtnsStyles,
    border:
      props.activeBtn === "checkin"
        ? `1px solid ${btmBtnsGrey}`
        : `1px solid ${jssVariables.colors.base_color}`,
    background:
      props.activeBtn === "checkin" ? btmBtnsGrey : jssVariables.colors.light,
    ..._.get(props, "customStyles.btmButtonCheckin", {}),
  }),
  btmButtonTimetables: (props) => ({
    ...btmBtnsStyles,
    border:
      props.activeBtn === "timetables"
        ? `1px solid ${btmBtnsGrey}`
        : `1px solid ${jssVariables.colors.base_color}`,
    background:
      props.activeBtn === "timetables"
        ? "btmBtnsGrey"
        : jssVariables.colors.light,
    ..._.get(props, "customStyles.btmButtonTimetables", {}),
  }),
  btmMessageContainer: (props) => ({
    display: "grid",
    placeItems: "center",
    borderRadius: `calc(${jssVariables.border_radius} / 2)`,
    color: jssVariables.colors.base_color,
    background: btmBtnsGrey,
    width: "100%",
    ..._.get(props, "customStyles.btmMessageContainer", {}),
  }),
  card: {},
  priceAndActionsContrMobile: (props) => ({
    ..._.get(props, "customStyles.priceAndActionsContrDesktop", {}),
  }),
  priceAndActionsContrDesktop: (props) => ({
    display: "none",
    ..._.get(props, "customStyles.priceAndActionsContrDesktop", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    Ferry: (props) => ({
      gridTemplateRows: "100%",
      gridTemplateColumns: `${jssVariables.card_img_width_desktop} 1fr`,
      boxShadow: jssVariables.shadows.smallShadow,
      width: props.isRoundtrip ? "100%" : "60rem",
      borderRadius: jssVariables.border_radius,
      ..._.get(props, "customStyles.Ferry.smallscreen", {}),
    }),
    placeholderParagraph: (props) => ({
      gridColumn: "span 2",
      ..._.get(props, "customStyles.placeholderParagraph.smallscreen", {}),
    }),
    header: (props) => ({
      gridTemplateColumns: "1fr  max-content max-content",
      gridGap: `calc(${jssVariables.normal_gap} * 2.5)`,
      padding: jssVariables.normal_gap,
      alignItems: "center",
      ..._.get(props, "customStyles.header.smallscreen", {}),
    }),
    content: (props) => ({
      display: "grid",
      gridTemplateColumns: "1fr max-content 1fr",
      justifyItems: "center",
      gridGap: `0 ${jssVariables.double_gap}`,
      width: "100%",
      alignItems: "center",
      ..._.get(props, "customStyles.content.smallscreen", {}),
    }),
    priceAndActionsContrMobile: (props) => ({
      display: "none",
      ..._.get(
        props,
        "customStyles.priceAndActionsContrMobile.smallscreen",
        {}
      ),
    }),
    priceAndActionsContrDesktop: (props) => ({
      display: "block",
      ..._.get(
        props,
        "customStyles.priceAndActionsContrDesktop.smallscreen",
        {}
      ),
    }),
    provider: (props) => ({
      justifyContent: "start",
      ..._.get(props, "customStyles.provider.smallscreen", {}),
    }),
    labelFastest: (props) => ({
      ...labelBestSomethingStyles().smallscreen,
      ..._.get(props, "customStyles.labelFastest.smallscreen", {}),
    }),
    labelCheapest: (props) => ({
      ...labelBestSomethingStyles().smallscreen,
      ..._.get(props, "customStyles.labelCheapest.smallscreen", {}),
    }),
    dividerMobile: (props) => ({
      display: "none",
      ..._.get(props, "customStyles.dividerMobile.smallscreen", {}),
    }),
    dividerDesktop: (props) => ({
      display: "block",
      width: ".5rem",
      left: 0,
      height: "7rem",
      ..._.get(props, "customStyles.dividerDesktop.smallscreen", {}),
    }),
    btmInfoSection: (props) => ({
      display: "grid",
      gridColumn: "span 3",
      paddingTop: 0,
      gridGap: 0,
      ..._.get(props, "customStyles.btmInfoSection.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const Ferry = ({ ferry, page_session_id, idx }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  const { isRoundtrip, ferries_computed_data } = useSelector((state) => {
    return {
      isRoundtrip: state.FerrySearchForm.isRoundtrip,
      ferries_computed_data:
        getFilteredSessionFerriesSelector(state).computed_data,
    };
  });

  const customStyles = cStyler({
    type,
    brand,
    objName: "FerryStyles",
  });

  const classes = styles({
    isRoundtrip,
    customStyles,
  });

  const operator = _.get(ferry, "legs.0.operator", {});

  return (
    <Element className={classes.Ferry}>
      <div className={classes.card}>
        {!_.isEmpty(ferry) && (
          <React.Fragment>
            <div className={classes.header}>
              <div className={classes.provider}>
                <img
                  src={operator.logo}
                  onError={handleNonValidImgFn}
                  alt=""
                  className={classes.providerImg}
                />
                {operator.name}
              </div>
              <div className={classes.bestSmthContr}>
                {ferries_computed_data.fastest ===
                  _.get(ferry, "legs.0.duration_minutes", 0) && (
                  <span className={classes.labelFastest}>{t("fastest")}</span>
                )}
                {ferries_computed_data.cheapest ===
                  _.get(ferry, "price.value", 0) && (
                  <span className={classes.labelCheapest}>
                    {t("bestPrice")}
                  </span>
                )}
              </div>
              <div className={classes.priceAndActionsContrDesktop}>
                <PriceAndActions
                  ferry={ferry}
                  page_session_id={page_session_id}
                  customStyles={customStyles}
                />
              </div>
            </div>
            <div className={classes.content}>
              {_.get(ferry, "legs", []).map((leg, idx) =>
                !leg.is_return_leg ? (
                  <TripInfo key={idx} leg={leg} />
                ) : (
                  <React.Fragment key={idx}>
                    <img
                      src={common_assets_s3 + "/dashed_line_FER_mobile.svg"}
                      alt="divider"
                      className={classes.dividerMobile}
                    />
                    <img
                      src={common_assets_s3 + "/dashed_line_FER_desktop.svg"}
                      alt="divider"
                      className={classes.dividerDesktop}
                    />
                    <TripInfo leg={leg} />
                  </React.Fragment>
                )
              )}
            </div>
            <BtmInfo
              checkin_before_minutes={_.get(
                ferry,
                "legs.0.checkin_before_minutes",
                0
              )}
            />
            <div className={classes.priceAndActionsContrMobile}>
              <PriceAndActions
                idx={idx}
                ferry={ferry}
                page_session_id={page_session_id}
                customStyles={customStyles}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    </Element>
  );
};
Ferry.defaultProps = {
  ghost: false,
  ferry: null,
  page_session_id: "",
  idx: 0,
};
Ferry.propTypes = {
  ghost: PropTypes.bool,
  ferry: PropTypes.object,
  page_session_id: PropTypes.string,
  idx: PropTypes.number,
};
export default Ferry;
